import React from "react";
import { useNavigate } from "react-router-dom";
import { getAuth } from "firebase/auth";
import SEOHead from "../components/SEOHead";

function GetStarted() {
  const navigate = useNavigate();
  const auth = getAuth();

  const handleStart = () => {
    if (auth.currentUser) {
      navigate("/");
    } else {
      navigate("/auth");
    }
  };

  const templateStyle = {
  width: "100%",
  borderRadius: "10px",
  boxShadow: "0 10px 25px rgba(0,0,0,0.08)"
};

  return (
    <div style={{ padding: "40px", maxWidth: "1100px", margin: "0 auto" }}>

      <SEOHead
        title="Get Started"
        description="Build a resume that actually gets interviews. Use EmployPilot’s AI-powered resume builder, interview coach, and job strategy tools — free to start."
        canonical="https://employpilot.com/get-started"
      />

<h1
  style={{
    fontSize: "42px",
    fontWeight: "bold",
    lineHeight: "1.15",
  }}
>
  Build a Professional Resume in Under 30 Seconds.
</h1>

<p
  style={{
    fontSize: "18px",
    color: "#555",
    marginTop: "16px",
    maxWidth: "760px",
    lineHeight: "1.7",
  }}
>
  No complicated resume writing. No long forms. Just enter a few job details
  and let EmployPilot instantly generate a polished resume designed to help
  you land real interviews.
</p>

<p
  style={{
    marginTop: "14px",
    fontSize: "14px",
    color: "#777",
    fontWeight: "500",
  }}
>
  ✔ Secure account • ✔ No credit card required • ✔ AI-powered career tools
</p>

<button onClick={handleStart} style={btnPrimary}>
  Start My Resume Now — Free
</button>

<p
  style={{
    fontSize: "13px",
    color: "#888",
    marginTop: "10px",
  }}
>
  Takes less than 2 minutes • Secure signup • Professional PDF downloads
</p>


{/* 🔥 HERO SHOWCASE (REPLACES OLD IMAGES) */}
<div style={{ marginTop: "50px" }}>
  
  <h2 style={{ textAlign: "center" }}>
    Stand out with top of the line premium styles to choose from.
  </h2>

  <p style={{ textAlign: "center", color: "#666", marginTop: "10px" }}>
    Clean. Structured. Built to stand out instantly and get results quickly.
  </p>

  <div
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
      gap: "24px",
      marginTop: "30px"
    }}
  >
    {[
      "/assets/get-started/template-classic.png",
      "/assets/get-started/template-modern-blue.png",
      "/assets/get-started/template-executive-gold.png",
    ].map((img, i) => (
      <div
        key={i}
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 12px 30px rgba(0,0,0,0.1)",
          transition: "transform 0.2s ease"
        }}
      >
        <img
          src={img}
          alt="Resume Template"
          style={{
            width: "100%",
            display: "block"
          }}
        />
      </div>
    ))}
  </div>

  <div style={{
    marginTop: "30px",
    padding: "20px",
    backgroundColor: "#f8f9fa",
    borderRadius: "10px",
    textAlign: "center"
  }}>
    <p style={{ fontWeight: "bold" }}>
      Is EmployPilot Legit?
    </p>

    <p style={{ fontSize: "14px", color: "#666", marginTop: "6px" }}>
      Yes — EmployPilot is a structured career platform used by job seekers to improve resumes, prepare for interviews, and navigate the hiring process with confidence.
      No spam. No fake listings. No data selling.
    </p>
    

    <p style={{ fontSize: "13px", color: "#888", marginTop: "8px" }}>
      Your data stays private. We do not sell user information.
    </p>
  </div>

  <p style={{ marginTop: "20px", textAlign: "center", fontWeight: "bold" }}>
    Job seekers are already seeing major improvements just by fixing structure.
  </p>

</div>

<div style={{ marginTop: "50px", textAlign: "center" }}>
  <h2>
    <h2><h2>More Than a Resume Builder — Your Complete Career Platform</h2></h2>
  </h2>

  <p style={{ marginTop: "10px", color: "#777" }}>
  Used by job seekers across multiple countries actively improving their job search results.
  </p>

  <p style={{ color: "#666", marginTop: "10px" }}>
    Everything you need to build stronger applications, prepare for interviews, and confidently advance your career—all in one platform.
  </p>

  <div style={{ marginTop: "20px", fontSize: "16px" }}>

  <p>📄 Resume Builder → Build ATS-friendly resumes employers want to read.</p>

  <p>✉️ Cover Letter Generator → Position your value with personalized cover letters tailored to every application.</p>

  <p>🎯 Resume Critique → Improve your resume with AI-powered feedback.</p>

  <p>🎙 Interview Coach → Practice smarter and answer with confidence.</p>

  <p>📈 Career Advisor → Receive personalized career guidance and job search strategies.</p>

  <p>💼 LinkedIn Profile Builder → Strengthen your professional presence beyond your resume.</p>

  <p>👥 Community → Connect with other job seekers, ask questions, and learn what works.</p>

</div>
</div>

<div style={{ textAlign: "center", marginTop: "40px" }}>
  <button onClick={handleStart} style={btnPrimary}>
    Start My Resume — Free
  </button>
</div>

      <p style={{ marginTop: "10px", fontWeight: "bold" }}>
        Build it free. Access everything after signup.
      </p>

      {/* INTERVIEW COACH */}
      <h2 style={{ marginTop: "60px" }}>
  Most candidates fail interviews because they don’t know how to structure answers. This fixes that.
  Walk Into Interviews Knowing Exactly What To Say
</h2>

<p>
  Stop guessing your answers. Get structured, real-world guidance so you can respond with clarity and confidence.
</p>

      <div style={{ marginTop: "30px", textAlign: "center" }}>
        <img
          src="/assets/get-started/interview-coach.png"
          alt="Interview Coach Preview"
          style={{
            width: "100%",
            maxWidth: "800px",
            borderRadius: "12px",
            boxShadow: "0 8px 25px rgba(0,0,0,0.08)"
          }}
        />
      </div>

      <p style={{ marginTop: "10px", fontWeight: "bold" }}>
        Real answers. Real guidance. No guesswork.
      </p>

      {/* COMMUNITY */}
      <h2 style={{ marginTop: "60px" }}>
  See What’s Actually Working — In Real Time
</h2>

<p>
  Learn from real job seekers, real results, and real conversations about what employers actually respond to.
</p>

      <div style={{ marginTop: "30px", textAlign: "center" }}>
        <img
          src="/assets/get-started/community-join.png"
          alt="Community Preview"
          style={{
            width: "100%",
            maxWidth: "800px",
            borderRadius: "12px",
            boxShadow: "0 8px 25px rgba(0,0,0,0.08)"
          }}
        />
      </div>

      <p style={{ marginTop: "10px", fontWeight: "bold" }}>
        Learn faster. Apply smarter. Get better results.
      </p>

      {/* PROCESS */}
      <h2 style={{ marginTop: "60px" }}>
  Everything You Need — In One Place
</h2>

<ul>
  <li> Build a structured, high-impact resume</li>
  <li> Prepare for interviews with proven guidance</li>
  <li> Learn from real-world job search insights</li>
  <li> Improve faster with feedback and clarity</li>
</ul>

<p style={{ fontSize: "14px", color: "#777" }}>
  No fluff. Just what works.
</p>

<div style={{ marginTop: "70px", textAlign: "center" }}>
  <h2>
    Built for Real Life — Not Just Desktop
  </h2>

  <p style={{ color: "#666", marginTop: "10px" }}>
    Use EmployPilot anywhere. Desktop, iPhone, or Android — your workflow stays smooth and consistent.
  </p>

  <div style={{ marginTop: "20px", fontSize: "16px" }}>
    <p>• Generate resumes on desktop or mobile</p>
    <p>• Instantly download and save PDFs on iOS & Android</p>
    <p>• Access your tools anywhere, anytime</p>
  </div>

  <p style={{ marginTop: "15px", fontWeight: "bold" }}>
    Same system. Same results. Every device.
  </p>
</div>

{/* FINAL CTA */}
<div style={{ marginTop: "80px", textAlign: "center" }}>
  <h2>
    The Gap Is Getting Wider.
    <br />
    You Can Either Guess — or Get Ahead.
  </h2>

  <p style={{ marginTop: "10px" }}>
    Start free. See the difference for yourself.
  </p>

  <p style={{ color: "#666" }}>
    No pressure. Just a smarter way to move forward.
  </p>

  <button onClick={handleStart} style={btnPrimary}>
    Start Building My Resume — Free
  </button>

  {/* PLATFORM LINE */}
  <p style={{
    fontSize: "13px",
    color: "#888",
    marginTop: "18px"
  }}>
    Available on iOS, Android, and Desktop
  </p>

  {/* BADGES */}
  <div style={{
    marginTop: "12px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "14px",
    flexWrap: "wrap"
  }}>
    <a
      href="https://apps.apple.com/us/app/employpilot/id6756582912"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        src="/assets/badges/app-store.png"
        alt="Download on the App Store"
        style={{ height: "45px" }}
      />
    </a>

    <a
      href="https://play.google.com/store/apps/details?id=com.ransdigishop.employpilot"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        src="/assets/badges/google-play.png"
        alt="Get it on Google Play"
        style={{ height: "45px" }}
      />
    </a>
  </div>
</div>

{/* FOOTER */}
<div style={{
  marginTop: "80px",
  textAlign: "center",
  fontSize: "14px",
  color: "#777"
}}>
  © 2026 EmployPilot. All Rights Reserved. | Terms of Use | Privacy Policy | Contact
</div>

</div>  

);
}

const btnPrimary = {
  backgroundColor: "#007bff",
  color: "#fff",
  padding: "14px 24px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer",
  marginTop: "20px",
  fontWeight: "bold"
};

export default GetStarted;